// extracted by mini-css-extract-plugin
module.exports = {"background":"circleIcon-module--background--1ZH03"};